export default __webpack_public_path__ + "static/media/readReviews.2f65855e.png";